import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/opt/buildhome/repo/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/opt/buildhome/repo/markdoc/tags.js'
import * as nodes from '/opt/buildhome/repo/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Mendable API Concepts\ndescription: Learn the Mendable API concepts.\n---\n\n\n## Mendable API Concepts\n\nMendable API allow you to use Mendable Search in any project.\n\n### [Ingestion](/mendable-api/ingestion)\n\nIngestion is the process of connecting your data sources to Mendable. You can ingest your data via the Mendable platform or via the Mendable API.\n\n### [Conversation](/mendable-api/conversation)\n\nA conversation is a series of 'chats' between a user and a Mendable AI assistant. To be able to start a conversation, you need to create a new conversation using the Mendable API endpoint. That will return a `conversation_id` which you can use to start a chat. \n\n\n### [Chat](/mendable-api/chat)\n\nA chat is a single interaction between a user and a Mendable AI assistant. A chat is made up of a question and a response. The Mendable AI assistant uses the question to generate a response and saves on the respecitve conversation based on the `conversation_id`\n\n### History\n\nA history is a list of previous chats in a conversation. The Mendable AI assistant uses the history to allow users to ask followup questions. At the moment, you must track the history on the front end and pass it to the endpoint in this format.\n\n```json\n[\n { \"prompt\" : \"How do I create a new project?\", \"response\" : \"You can create a new project by going to the projects page and clicking the new project button.\" },\n { \"prompt\" : \"Ok, how do i rename it\", \"response\" : \"You cannot currently rename a project via the dashboard, contact Support for assistance.\" }\n]\n```\n\n### ANON_KEY vs API_KEY\n\nANON_KEY is safe to be used client-side. API_KEY is not. ANON_KEY is normally used with the [REACT components](/components/overview) and API_KEY is used with the [Mendable API](/mendable-api/overview).\n\n\n\n\n\n";
const filepath = "/mendable-api/concepts.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
